import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { withPermissionFallback } from "../../HOC/withPermissionFallback/withPermissionFallback";
import { SubtitleDescription } from "../subtitleDescription";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import commonStyles from "../../../containers/settings/settingsEditCommon.css";
import { StatusBox } from "./components/statusBox";
import { AgentStatusEdit } from "./editStatus/agentStatusEdit";
import { AppPermission, AppPresence } from "@closerplatform/spinner-openapi";

const statuses = Object.values(AppPresence);

export const AgentStatusesSettingsComponent = observer(() => {
  const [editedStatus, setEditedStatus] = useState<AppPresence>();

  const renderStatusesSection = () => {
    return statuses.map((status) => {
      const isEditable = isStatusEditable(status);
      return (
        <StatusBox
          key={status}
          status={status}
          onEdit={isEditable && (() => setEditedStatus(status))}
        />
      );
    });
  };

  const renderStatusesView = () => {
    return (
      <>
        <div className={commonStyles.title}>
          <L10n id="settings.advisers" />
        </div>
        <div className={commonStyles.section}>
          <SubtitleDescription
            subtitle={intl.formatMessage("settings.adviserStatuses.title")}
            description={intl.formatMessage("settings.adviserStatuses.description")}
          />
          <div className={commonStyles.content}>{renderStatusesSection()}</div>
        </div>
      </>
    );
  };

  return (
    <>
      {editedStatus ? (
        <AgentStatusEdit status={editedStatus} onGoBack={() => setEditedStatus(undefined)} />
      ) : (
        renderStatusesView()
      )}
    </>
  );
});

export const AgentStatusesSettings = withPermissionFallback<{}>(
  AppPermission.SettingsStatuses,
  AgentStatusesSettingsComponent
);

const isStatusEditable = (status: AppPresence) =>
  status !== AppPresence.Unavailable ? undefined : status;
